import React, { useRef, useEffect, memo } from "react";
import { Container } from "@pixi/react";
import { useDispatch, useSelector } from "react-redux";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import Overlay from "../../../../Games/Shared/Overlay/Overlay";
import FreeSpinRetriggerController from "./FreeSpinRetriggerController";
import { safeInit } from "../../../../utilities";
import { selectShowFreeSpinRetrigger } from "../../../../State/Slices/animationsSlice";

const FreeSpinRetriggerDialog = () => {
  const dispatch = useDispatch();
  const showFreeSpinRetrigger = useSelector(selectShowFreeSpinRetrigger);

  const retriggerControllerRef = useRef(null);
  const spineContainerRef = useRef(null);
  const overlayRef = useRef(null);
  const { dimensions, symbolHeight, device, orientation } = useDimensions();

  // Initialize once
  useEffect(() => {
    if (spineContainerRef.current && !retriggerControllerRef.current) {
      safeInit(() => {
        retriggerControllerRef.current = new FreeSpinRetriggerController(
          spineContainerRef.current,
          dimensions,
          dispatch,
          symbolHeight,
          overlayRef,
          device,
          orientation,
        );
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle dimension changes
  useEffect(() => {
    if (retriggerControllerRef.current) {
      retriggerControllerRef.current.updateDimensions(
        dimensions,
        symbolHeight,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [symbolHeight]);

  // Handle device/orientation changes
  useEffect(() => {
    if (retriggerControllerRef.current) {
      retriggerControllerRef.current.updateDeviceInfo(device, orientation);
    }
  }, [device, orientation]);

  // Start animation when triggered
  useEffect(() => {
    if (retriggerControllerRef.current && showFreeSpinRetrigger) {
      retriggerControllerRef.current.playAnimation();
    }
  }, [showFreeSpinRetrigger]);

  // Cleanup
  useEffect(() => {
    return () => {
      if (retriggerControllerRef.current) {
        retriggerControllerRef.current.cleanup();
        retriggerControllerRef.current = null;
      }
    };
  }, []);

  return (
    <Container ref={spineContainerRef} name="free_spin_retrigger" zIndex={9}>
      <Overlay ref={overlayRef} dimensions={dimensions} eventMode="none" />
    </Container>
  );
};

export default memo(FreeSpinRetriggerDialog);
